import { statisticsConfig } from '@/utils/statisticsConfig'



export const staticType = {
    'proinfo':{
        check:()=> {statisticsConfig.insur_insurinfoinput_ClauseBox_submit_click()},
        close:()=> {statisticsConfig.insur_insurinfoinput_ClauseBox_close_click()},
        treatyshow:()=> {statisticsConfig.insur_insurinfoinput_ClauseBox_clause_click()},
        showBox:()=>{statisticsConfig.insur_insurinfoinput_ClauseBox_click()}
    },
    'insurinfoinput':{
        check:()=> {statisticsConfig.insur_insurinfoinput_ClauseBox_submit_click()},
        close:()=> {statisticsConfig.insur_insurinfoinput_ClauseBox_close_click()},
        treatyshow:()=> {statisticsConfig.insur_insurinfoinput_ClauseBox_clause_click()},
        showBox:()=>{statisticsConfig.insur_insurinfoinput_ClauseBox_click()}
    }
}